function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLineChartWidget = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 50,
  viewBox: "0 0 128 100"
}, props), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line Chart",
  d: "M6 94H2V6h4v84h120v4H6Zm104-54a6 6 0 1 1 6-6 6 6 0 0 1-6 6ZM84.281 25.606a9.945 9.945 0 0 0 1.531-3.691l15.825 6.61a9.946 9.946 0 0 0-1.473 3.715ZM76 26a6 6 0 1 1 6-6 6 6 0 0 1-6 6Zm-1.291 3.907L63.6 65.712a9.944 9.944 0 0 0-3.713-1.529l11.038-35.577a9.919 9.919 0 0 0 3.784 1.301ZM64 74a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-27.39-4.932a9.921 9.921 0 0 0 1.3-3.771l11.323 3.893A9.93 9.93 0 0 0 48.051 73ZM28 70a6 6 0 1 1 6-6 6 6 0 0 1-6 6ZM10 84.025v-5.49l9.564-9.181a10.041 10.041 0 0 0 2.74 2.86Z",
  style: {
    fillRule: "evenodd"
  }
}));
SvgLineChartWidget.displayName = "SvgLineChartWidget";
export { SvgLineChartWidget as ReactComponent };
export default SvgLineChartWidget;